/** استخراج فایل واقعی از لیست Upload آنت‌دیزاین */
export function getUploadFile(fileList) {
  const files = getUploadFiles(fileList);
  return files[0] || null;
}

/** استخراج همه فایل‌های آپلودشده از لیست Upload */
export function getUploadFiles(fileList) {
  if (!fileList?.length) return [];
  return fileList
    .map((item) => {
      if (item?.originFileObj) return item.originFileObj;
      if (item instanceof File || item instanceof Blob) return item;
      return null;
    })
    .filter(Boolean);
}

/** تبدیل taxes محصول API به آرایه id برای فرم */
export function parseProductTaxIds(taxes) {
  if (!taxes) return [];
  if (Array.isArray(taxes)) {
    return taxes.map((t) => Number(t?.id ?? t)).filter((id) => !Number.isNaN(id));
  }
  return [];
}

/** آدرس تصویر محصول از files یا images */
export function getProductImageUrl(product, imagesRaw) {
  if (product?.image_url) return product.image_url;
  const files = product?.files;
  if (Array.isArray(files) && files.length) {
    const preferred = files.find((f) => f.default_status) || files[0];
    if (preferred?.file_url) return preferred.file_url;
  }
  if (imagesRaw) {
    try {
      const parsed = typeof imagesRaw === 'string' ? JSON.parse(imagesRaw) : imagesRaw;
      if (Array.isArray(parsed) && parsed[0]?.file_url) return parsed[0].file_url;
    } catch {
      /* ignore */
    }
  }
  return null;
}

/** ساخت پیلود استاندارد محصول مطابق API */
export function buildProductPayload(formValues, { imageFiles, downloadableFile, deleteDownloadableFile = false } = {}) {
  const taxRaw = formValues.tax;
  const tax = Array.isArray(taxRaw)
    ? taxRaw.map((id) => Number(id)).filter((id) => !Number.isNaN(id))
    : taxRaw != null && taxRaw !== ''
      ? [Number(taxRaw)].filter((id) => !Number.isNaN(id))
      : [];

  const payload = {
    name: formValues.name,
    price: String(formValues.price ?? 0),
    tax,
    description: formValues.description ?? '',
    sku: formValues.sku ?? '',
    unit_type: Number(formValues.unit_type),
    allow_purchase: formValues.allow_purchase ? 'yes' : 'no',
    downloadable: formValues.downloadable ? true : null,
    category_id: formValues.category_id ?? null,
    sub_category_id: formValues.sub_category_id ?? null,
  };

  if (imageFiles?.length) {
    payload.file = imageFiles;
  }

  if (deleteDownloadableFile) {
    payload.downloadable = false;
    payload.downloadable_file = '';
  } else if (formValues.downloadable) {
    payload.downloadable = true;
    if (downloadableFile) {
      payload.downloadable_file = downloadableFile;
    }
  }

  return payload;
}

/** آیا پیلود محصول شامل فایل آپلودی است؟ */
export function productPayloadHasFiles(payload) {
  if (payload.file?.length) return true;
  const downloadableFile = payload.downloadable_file;
  return downloadableFile instanceof File || downloadableFile instanceof Blob;
}

/** پیلود JSON محصول — tax به صورت آرایه: "tax": [1] */
export function serializeProductJsonPayload(payload) {
  const body = {
    name: payload.name,
    price: payload.price,
    tax: Array.isArray(payload.tax) ? payload.tax : [],
    description: payload.description ?? '',
    sku: payload.sku ?? '',
    unit_type: payload.unit_type,
    allow_purchase: payload.allow_purchase,
    downloadable:
      payload.downloadable === true ? true : payload.downloadable === false ? false : null,
    category_id: payload.category_id ?? null,
    sub_category_id: payload.sub_category_id ?? null,
  };

  if (Object.prototype.hasOwnProperty.call(payload, 'downloadable_file')) {
    body.downloadable_file = payload.downloadable_file;
  }

  return body;
}

/** پر کردن FormData برای ایجاد/ویرایش محصول */
export function appendProductFormData(formData, payload) {
  formData.append('name', payload.name);
  formData.append('price', payload.price);

  if (Array.isArray(payload.tax) && payload.tax.length) {
    payload.tax.forEach((id, index) => {
      formData.append(`tax[${index}]`, String(id));
    });
  }

  if (payload.description != null && payload.description !== '') {
    formData.append('description', payload.description);
  }

  if (payload.sku != null && payload.sku !== '') {
    formData.append('sku', payload.sku);
  }

  formData.append('unit_type', payload.unit_type);
  formData.append('allow_purchase', payload.allow_purchase);

  if (payload.downloadable === true) {
    formData.append('downloadable', 'true');
  } else if (payload.downloadable === false) {
    formData.append('downloadable', 'false');
  }

  if (payload.category_id != null && payload.category_id !== '') {
    formData.append('category_id', payload.category_id);
  }

  if (payload.sub_category_id != null && payload.sub_category_id !== '') {
    formData.append('sub_category_id', payload.sub_category_id);
  }

  if (payload.file?.length) {
    payload.file.forEach((f, index) => {
      if (f) formData.append(`file[${index}]`, f);
    });
  }

  if (Object.prototype.hasOwnProperty.call(payload, 'downloadable_file')) {
    if (payload.downloadable_file === null || payload.downloadable_file === '') {
      formData.append('downloadable_file', '');
    } else if (payload.downloadable_file) {
      formData.append('downloadable_file', payload.downloadable_file);
    }
  }
}
